const TOP_SUB_PACKAGE_ID = Number(
  process.env.REACT_APP_TOP_SUB_PACKAGE_ID || 49
);
const LEGENDARY_SUB_PACKAGE_ID = Number(
  process.env.REACT_APP_LEGENDARY_SUB_PACKAGE_ID || 48
);

export const SUBSCRIPTION_DISCOUNT_PERCENT = 30;

export const isTopSubscriptionPackage = (packageId: string | number) =>
  Number(packageId) === TOP_SUB_PACKAGE_ID;

export const isLegendarySubscriptionPackage = (packageId: string | number) =>
  Number(packageId) === LEGENDARY_SUB_PACKAGE_ID;

export const isDiscountEligibleSubscriptionPackage = (
  packageId: string | number
) =>
  isTopSubscriptionPackage(packageId) ||
  isLegendarySubscriptionPackage(packageId);

export const getFirstMonthDiscountedPrice = (
  price: number | string,
  discountPercent = SUBSCRIPTION_DISCOUNT_PERCENT
) => {
  const amount = Number(price || 0);
  return Number((amount * (1 - discountPercent / 100)).toFixed(2));
};
